import React, { useRef } from "react";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import "./style.scss";

const ImageUpload = (props) => {
  const { imageURL, defaultIcon, defaultText, handleDeleteImage, handleImageStateUpdate, handleErrorMessage, ...rest } =
    props;
  let imageBlob = "";
  const maxSize = 5000000;
  const allowedTypes = ["jpg", "jpeg", "svg", "png", "webp", "avif"];
  const imageRef = useRef(null);

  const handleImageUpload = (event) => {
    event.preventDefault();
    imageRef.current.click();
  };

  const fileToDataUri = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target.result);
        imageBlob = event.target.result;
      };
      reader.readAsDataURL(file);
    });

  const handleImageChange = (event) => {
    const uploadedFile = imageRef.current.files[0];
    if (uploadedFile) {
      const fileExtension = uploadedFile?.name?.split(".")?.pop().toLowerCase();
      const fileSize = uploadedFile.size;
      if (fileSize <= maxSize && allowedTypes.includes(fileExtension)) {
        handleErrorMessage?.("");
        fileToDataUri(uploadedFile).then(() => {
          handleImageStateUpdate(imageBlob);
        });
      } else {
        handleImageStateUpdate("", "");
        if (!(fileSize <= maxSize)) {
          if (handleErrorMessage) {
            handleErrorMessage?.("Image upload failed. File size exceeds 5mb limit.");
          } else {
            toast.error("Image upload failed. File size exceeds 5mb limit.");
          }
        }
        if (!allowedTypes.includes(fileExtension)) {
          if (handleErrorMessage) {
            handleErrorMessage(`Unsupported file type. Acceptable formats: ${allowedTypes.join(", ")}`);
          } else {
            toast.error(`Unsupported file type. Acceptable formats: ${allowedTypes.join(", ")}`);
          }
        }
      }
    }
  };

  const deleteImage = () => {
    imageRef.current.value = "";
    handleDeleteImage("");
  };

  return (
    <div
      {...rest}
      className={`relative ${rest.className}`}
      style={{ ...rest.style, ...(imageURL ? { borderStyle: "solid" } : {}) }}
    >
      <div className="">
        <Button
          variant="primary"
          onClick={imageURL ? deleteImage : handleImageUpload}
          className="position-absolute rounded-circle d-flex align-items-center justify-content-center"
          style={{
            width: "40px",
            height: "40px",
            top: "-15px",
            right: "-25px",
          }}
        >
          <span className={imageURL ? "logo_remove" : "logo_add"}>{imageURL ? <>&#10005;</> : "+"}</span>
        </Button>

        <input
          type="file"
          id="file"
          ref={imageRef}
          onChange={handleImageChange}
          accept=".jpeg, .jpg, .svg, .png, .webp, .avif"
          hidden
        />
      </div>
      <div
        className="upload_image_wrapper"
        style={imageURL ? { borderStyle: "solid" } : {}}
        onClick={handleImageUpload}
      >
        {imageURL ? (
          <>
            <img src={imageURL} alt="logo" style={{ width: "100%", height: "100%" }} className="object-fit-contain" />
          </>
        ) : (
          <>
            <img src={defaultIcon} alt="upload-icon" style={{ width: "20px", height: "20px" }} />
            <span>{defaultText}</span>
          </>
        )}
      </div>
    </div>
  );
};
export default ImageUpload;
